export default __webpack_public_path__ + "static/media/rans____.3a7f9d97.ttf";